import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @export
 * Header bar for a configuration section — renders title on the left and optional
 * action buttons on the right. Uses the same styling as ConfigurationView's built-in
 * section header so it can be used directly inside `hideHeader: true` sections for
 * consistent appearance.
 *
 * @example
 * ```tsx
 * // Inside a component used in a hideHeader:true section
 * <ConfigurationViewHeader
 *   title="Login Page Configuration"
 *   actions={<>
 *     <ButtonComponent title="Reset" onClick={handleReset} variant="secondary" />
 *     <ButtonComponent title="Save" onClick={handleSave} />
 *   </>}
 * />
 * ```
 */
export const ConfigurationViewHeader = ({ title, actions, variant = 'section' }) => {
    if (variant === 'main') {
        return (_jsxs("div", { className: 'uxpcore_configview__header', children: [_jsx("div", { className: 'uxpcore_configview__title', children: title }), actions && (_jsx("div", { className: 'uxpcore_configview__header-actions', children: actions }))] }));
    }
    return (_jsxs("div", { className: 'uxpcore_configview__content-header', children: [_jsx("div", { className: 'uxpcore_configview__content-title', children: title }), actions && (_jsx("div", { className: 'uxpcore_configview__content-actions', children: actions }))] }));
};
